import { Component, InjectionToken, OnInit } from '@angular/core';
import { Persona } from 'src/app/models/personas.interface';
import { ManagePersonasViewComponent } from './view/manage-personas-view.component';
import { ManagePersonasData, PersonaComponentData } from './manage-personas-data';
import { ManagePersonasEditComponent } from './edit/manage-personas-edit.component';

export const token = new InjectionToken<string>('testing');

@Component({
  selector: 'app-manage-personas',
  templateUrl: './manage-personas.component.html',
  styleUrls: ['./manage-personas.component.scss']
})
export class ManagePersonasComponent implements OnInit {
  personas: Persona[] = [];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public activeComponent: any = ManagePersonasViewComponent;
  public selectedPersona!: Persona | undefined;
  public personaTitles!: string[] | undefined;

  constructor(private managePersonasData: ManagePersonasData) {}

  ngOnInit(): void {
    this.managePersonasData.getObservable().subscribe((personaComponentData: PersonaComponentData) => {
      this.selectedPersona = personaComponentData.persona;
      this.personaTitles = personaComponentData.personaTitles;
      this.updateChildView(personaComponentData.componentName);
    });
  }

  updateChildView(componentName: string) {
    let component: object = ManagePersonasViewComponent;
    switch (componentName) {
      case ManagePersonasEditComponent.name:
        component = ManagePersonasEditComponent;
        break;
      case ManagePersonasViewComponent.name:
        component = ManagePersonasViewComponent;
        break;
      default:
        console.error(`Unknowen child component: ${ManagePersonasViewComponent.name}`);
        return;
    }
    this.activeComponent = component;
  }
}
